import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function MySlider({ slides }) {
    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        cssEase: "linear", pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div className="slider-container">
            <Slider {...settings}>
                {slides.map((slide, index) => {
                    if (slide.mediaType === 'image') {
                        return (
                            <div className="content-center" key={index}>
                                <img src={slide.mediaUrl} alt={slide.title} width={'90%'} height={'90%'} style={{
                                    alignSelf: 'center'
                                }} />
                            </div>
                        )
                    }
                    if (slide.mediaType === 'video') {
                        return (
                            <div className="content-center" key={index}>
                                <video controls>
                                    <source src={slide.mediaUrl} type={`video/${slide.mediaUrl.split('.').pop()}`} width={'90%'} height={'90%'} style={{
                                        alignSelf: 'center'
                                    }} />
                                </video>
                            </div>
                        )
                    }
                    return null
                })}
            </Slider>
        </div>
    );
}

export default MySlider;